const words = ["PORTO", "ZONAS ENVOLVENTES", "MARCAÇÃO ONLINE", "PEDIDO DE VISITA", "PROBLEMA360", "PROFISSIONALISMO"];

export default function EditorialMarquee() {
  return (
    <div className="marquee-viewport" data-testid="service-area-marquee" aria-label="Áreas e compromissos da Problema360">
      <div className="marquee-track">
        {[...words, ...words].map((word, index) => (
          <span key={`${word}-${index}`}>
            {word} <b aria-hidden="true">✳</b>
          </span>
        ))}
      </div>
    </div>
  );
}
